import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { timeSlotsBranchServices } from 'api/services'
import { IResTimeSlot } from 'api/services/timeslots-branches/types'
import LangList from 'components/LangList/LangList'
import TimeSlots from 'components/TimeSlots/TimeSlots'
import ReserveQueue from 'components/Popup/components/ReserveQueue/ReserveQueue'
import Popup from 'components/Popup/Popup'
import Logo from 'assets/images/logo-svg.svg'
import Back from 'assets/images/back.png'
import './ScheduleTimePage.sass'
import { useSelector } from 'react-redux'
import { AppState } from 'store/store'



const ScheduleTimePage: React.FC = () => {
  const [data, setData] = useState<IResTimeSlot[]>([])
  const [timeSlot, setTimeSlot] = useState<IResTimeSlot>()
  const router = useNavigate()
  const [searchParams] = useSearchParams();
  const branchId = searchParams.get('branchId');
	const { scheduleId } = useParams<{ scheduleId: string }>();
  const ref = useRef<any>(null)
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.pages.ScheduleTimePage,
  );
  

  useEffect(() => {
    if (!branchId || !scheduleId) return;
  
    getData();
  
    const interval = setInterval(() => {
      getData();
    }, 6000);
  
    return () => clearInterval(interval);
  }, [scheduleId, branchId]);

  const getData = async () => {
		const params = {
			date: scheduleId,
			branchId: Number(branchId)
		} as any
		const res = await timeSlotsBranchServices.getTimeSlots(params).then((res) => res.data)
		setData(res)
	}
  
  const openReserveModal = (val: IResTimeSlot) => {
    ref.current.onShow()
    setTimeSlot(val)
  }

  const backHandler = () => {
    router('/schedule')
  }

  const times = data.filter(i => i.forLaw).map(i => i.fromTime).join('; ')


  return (
    <div className="schedule-time-page">
      <div className="schedule-time-page__back-wrap" onClick={backHandler}>
        <img src={Back} alt="" className="schedule-time-page__back" />
      </div>
      <div className="schedule-time-page__logo-wrap">
        <img src={Logo} alt="" className="schedule-time-page__logo" />
        <div className="schedule-time-page__logo-name">IMTIHON<br />MARKAZI</div>
      </div>
      <div className="schedule-time-page__text">
        {i18n.lawText?.replace('{{times}}', times)}
      </div>
      <TimeSlots 
        slots={data}
        onClick={(val) => openReserveModal(val)}
      />
      <LangList/>
      <Popup top={true} ref={ref} notClosing>
        <ReserveQueue lawTimeSlots={data} data={timeSlot} closeHandler={() => ref.current.onHide()}/>
      </Popup>
    </div>
  )
}

export default ScheduleTimePage